const SET_USER = (state, payload) => {
  state.id = payload.id
  state.name = payload.name
  state.email = payload.email
}

export default {
  SET_USER
}



// WEBPACK FOOTER //
// ./src/store/modules/user/mutations.js